import request from '../request'

/**
 * 获取项目列表
 */
export function getProjectList(params) {
    return request({
        url: '/market-service/scrm/project/list',
        method: 'GET',
        params,
    })
}
export function getProjectOptions(params) {
    return request({
        url: '/market-service/scrm/project/options',
        method: 'GET',
        params,
    })
}

/**
 * 新增项目
 */
export function addProject(data) {
    return request({
        url: '/market-service/scrm/project/add',
        method: 'POST',
        data,
    })
}

/**
 * 修改项目
 */
export function updateProject(data) {
    return request({
        url: '/market-service/scrm/project/update',
        method: 'POST',
        data,
    })
}

/**
 * 删除项目
 */
export function deleteProject(id) {
    return request({
        url: `/market-service/scrm/project/delete/${id}`,
        method: 'POST',
    })
}

/**
 * 获取项目详情
 */
export function getProjectDetail(id) {
    return request({
        url: `/market-service/scrm/project/query/${id}`,
        method: 'GET',
    })
}

/**
 * 关闭项目
 */
export function closeProject(id, closeReason) {
    return request({
        url: `/market-service/scrm/project/close/${id}`,
        method: 'POST',
        params: { closeReason },
    })
}

export function projectBidFeedbackAdd(data) {
    return request({
        url: `/market-service/scrm/project/bid/feedback/add`,
        method: 'POST',
        data
    })
}
export function projectBidFeedbackUpdate(data) {
    return request({
        url: `/market-service/scrm/project/bid/feedback/update`,
        method: 'POST',
        data
    })
}

/**
 * 根据项目ID获取投标反馈信息
 */
export function getProjectBidFeedback(projectId) {
    return request({
        url: `/market-service/scrm/project/bid/feedback/queryByProject/${projectId}`,
        method: 'GET'
    })
}
